import { api } from '@/services/api';

export interface AnalyzeVideoResponse {
  jobId: string;
}

export const analyzeVideo = async (videoId: string): Promise<AnalyzeVideoResponse> => {
  if (!videoId || videoId.trim().length === 0) {
    throw new Error('Video ID is required');
  }

  const response = await api.post<AnalyzeVideoResponse>(`/audio/analyze/${videoId}`);

  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to queue analysis');
  }

  return response.data;
};

export const getAudioFeaturesForVideo = async (videoDbId: string): Promise<unknown | null> => {
  try {
    const response = await api.get<any>(`/audio/features/${videoDbId}`);
    if (!response.success || !response.data) return null;
    return response.data.audioFeatures ?? response.data;
  } catch {
    return null;
  }
};
